<template>
    <div class="notification-card-list" v-bind:class="read ? 'read' : ''">
        <div>
            <div class="notification-badge" v-bind:class="color"></div>
        </div>
        <div class="notification-card-list-desc">
            <div class="notification-card-list-title">
                {{text}}
            </div>
            <div class="notification-card-list-date">
                {{ moment() }}
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/id';
export default {
    props: {
        color: String,
        date: String,
        text: String,
        read: Boolean
    },
    methods: {
        moment () {
            return moment(this.date, "YYYY-MM-DD hh:mm:ss").locale('id').format("dddd, D MMMM YYYY HH:mm");
        }
    },
    name: "CardRiwayat"
}
</script>

<style scoped>
.notification-card-list {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 15px;
}
.notification-card-list .notification-card-list-desc {
    padding-left: 10px;
}
.notification-card-list .notification-card-list-title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
}

.notification-card-list.read .notification-card-list-title {
    color: #828282;
}

.notification-card-list .notification-card-list-date {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #828282;
}
</style>
